import { FC } from 'react'

import './style.scss'

type LinkProps = {
  className?: string,
  style?: any,
  color?: string,
  size?: number,
  showOnly?: 'sm' | 'md' | 'lg'
}

const Card:FC<LinkProps> = ({ children, className = '', style, color = 'gray-700', size, showOnly, ...rest })  => {
  return (
    <div className={`${showOnly ? showOnly + ':card': 'card'} ${color ? 'text-' + color : ''} ${size ? 'fz-' + size : ''} ${className}`} style={style} {...rest}>{children}</div>
  )
}

export { Card }